import React, { Component } from 'react';

class FourOhFour extends Component {

    render(){
        return (
            <div className="four-oh-four">
                OOPS, Page not found
            </div>
        )
    }
}

export default FourOhFour;



// WEBPACK FOOTER //
// ./src/components/FourOhFour/FourOhFour.js